/**
 * Allows to discard null from a type
 * Useful for .filter() of type Array<T | null>
 */
export const notNullGuard = <T>(item: T): item is Exclude<T, null> => item !== null
